export default [
  {
    inClass: 'animated-section-moveFromRight',
    outClass: 'animated-section-moveToLeft'
  },
  {
    inClass: 'animated-section-moveFromLeft',
    outClass: 'animated-section-moveToRight'
  },
  {
    inClass: 'animated-section-moveFromBottom',
    outClass: 'animated-section-moveToTop'
  },
  {
    inClass: 'animated-section-moveFromTop',
    outClass: 'animated-section-moveToBottom'
  },
  {
    inClass: 'animated-section-moveFromRight animated-section-ontop',
    outClass: 'animated-section-fade'
  },
  {
    inClass: 'animated-section-moveFromLeft animated-section-ontop',
    outClass: 'animated-section-fade'
  },
  {
    inClass: 'animated-section-moveFromBottom animated-section-ontop',
    outClass: 'animated-section-fade'
  },
  {
    inClass: 'animated-section-moveFromTop animated-section-ontop',
    outClass: 'animated-section-fade'
  },
  {
    inClass: 'animated-section-moveFromRightFade',
    outClass: 'animated-section-moveToLeftFade'
  },
  {
    inClass: 'animated-section-moveFromLeftFade',
    outClass: 'animated-section-moveToRightFade'
  },
  {
    inClass: 'animated-section-moveFromBottomFade',
    outClass: 'animated-section-moveToTopFade'
  },
  {
    inClass: 'animated-section-moveFromTopFade',
    outClass: 'animated-section-moveToBottomFade'
  },
  {
    inClass: 'animated-section-moveFromRight',
    outClass: 'animated-section-moveToLeftEasing animated-section-ontop'
  },
  {
    inClass: 'animated-section-moveFromLeft',
    outClass: 'animated-section-moveToRightEasing animated-section-ontop'
  },
  {
    inClass: 'animated-section-moveFromBottom',
    outClass: 'animated-section-moveToTopEasing animated-section-ontop'
  },
  {
    inClass: 'animated-section-moveFromTop',
    outClass: 'animated-section-moveToBottomEasing animated-section-ontop'
  },
  {
    inClass: 'animated-section-moveFromRight animated-section-ontop',
    outClass: 'animated-section-scaleDown'
  },
  {
    inClass: 'animated-section-moveFromLeft animated-section-ontop',
    outClass: 'animated-section-scaleDown'
  },
  {
    inClass: 'animated-section-moveFromBottom animated-section-ontop',
    outClass: 'animated-section-scaleDown'
  },
  {
    inClass: 'animated-section-moveFromTop animated-section-ontop',
    outClass: 'animated-section-scaleDown'
  },
  {
    inClass: 'animated-section-scaleUpDown animated-section-delay300',
    outClass: 'animated-section-scaleDown'
  },
  {
    inClass: 'animated-section-scaleUp animated-section-delay300',
    outClass: 'animated-section-scaleDownUp'
  },
  {
    inClass: 'animated-section-scaleUp',
    outClass: 'animated-section-moveToLeft animated-section-ontop'
  },
  {
    inClass: 'animated-section-scaleUp',
    outClass: 'animated-section-moveToRight animated-section-ontop'
  },
  {
    inClass: 'animated-section-scaleUp',
    outClass: 'animated-section-moveToTop animated-section-ontop'
  },
  {
    inClass: 'animated-section-scaleUp',
    outClass: 'animated-section-moveToBottom animated-section-ontop'
  },
  {
    inClass: 'animated-section-scaleUpCenter animated-section-delay400',
    outClass: 'animated-section-scaleDownCenter'
  },
  {
    inClass: 'animated-section-moveFromRight animated-section-delay200 animated-section-ontop',
    outClass: 'animated-section-rotateRightSideFirst'
  },
  {
    inClass: 'animated-section-moveFromLeft animated-section-delay200 animated-section-ontop',
    outClass: 'animated-section-rotateLeftSideFirst'
  },
  {
    inClass: 'animated-section-moveFromTop animated-section-delay200 animated-section-ontop',
    outClass: 'animated-section-rotateTopSideFirst'
  },
  {
    inClass: 'animated-section-moveFromBottom animated-section-delay200 animated-section-ontop',
    outClass: 'animated-section-rotateBottomSideFirst'
  },
  {
    inClass: 'animated-section-flipInLeft animated-section-delay500',
    outClass: 'animated-section-flipOutRight'
  },
  {
    inClass: 'animated-section-flipInRight animated-section-delay500',
    outClass: 'animated-section-flipOutLeft'
  },
  {
    inClass: 'animated-section-flipInBottom animated-section-delay500',
    outClass: 'animated-section-flipOutTop'
  },
  {
    inClass: 'animated-section-flipInTop animated-section-delay500',
    outClass: 'animated-section-flipOutBottom'
  },
  {
    inClass: 'animated-section-scaleUp',
    outClass: 'animated-section-rotateFall animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateInNewspaper animated-section-delay500',
    outClass: 'animated-section-rotateOutNewspaper'
  },
  {
    inClass: 'animated-section-moveFromRight',
    outClass: 'animated-section-rotatePushLeft'
  },
  {
    inClass: 'animated-section-moveFromLeft',
    outClass: 'animated-section-rotatePushRight'
  },
  {
    inClass: 'animated-section-moveFromBottom',
    outClass: 'animated-section-rotatePushTop'
  },
  {
    inClass: 'animated-section-moveFromTop',
    outClass: 'animated-section-rotatePushBottom'
  },
  {
    inClass: 'animated-section-rotatePullRight animated-section-delay180',
    outClass: 'animated-section-rotatePushLeft'
  },
  {
    inClass: 'animated-section-rotatePullLeft animated-section-delay180',
    outClass: 'animated-section-rotatePushRight'
  },
  {
    inClass: 'animated-section-rotatePullBottom animated-section-delay180',
    outClass: 'animated-section-rotatePushTop'
  },
  {
    inClass: 'animated-section-rotatePullTop animated-section-delay180',
    outClass: 'animated-section-rotatePushBottom'
  },
  {
    inClass: 'animated-section-moveFromRightFade',
    outClass: 'animated-section-rotateFoldLeft'
  },
  {
    inClass: 'animated-section-moveFromLeftFade',
    outClass: 'animated-section-rotateFoldRight'
  },
  {
    inClass: 'animated-section-moveFromBottomFade',
    outClass: 'animated-section-rotateFoldTop'
  },
  {
    inClass: 'animated-section-moveFromTopFade',
    outClass: 'animated-section-rotateFoldBottom'
  },
  {
    inClass: 'animated-section-rotateUnfoldLeft',
    outClass: 'animated-section-moveToRightFade'
  },
  {
    inClass: 'animated-section-rotateUnfoldRight',
    outClass: 'animated-section-moveToLeftFade'
  },
  {
    inClass: 'animated-section-rotateUnfoldTop',
    outClass: 'animated-section-moveToBottomFade'
  },
  {
    inClass: 'animated-section-rotateUnfoldBottom',
    outClass: 'animated-section-moveToTopFade'
  },
  {
    inClass: 'animated-section-rotateRoomLeftIn',
    outClass: 'animated-section-rotateRoomLeftOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateRoomRightIn',
    outClass: 'animated-section-rotateRoomRightOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateRoomTopIn',
    outClass: 'animated-section-rotateRoomTopOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateRoomBottomIn',
    outClass: 'animated-section-rotateRoomBottomOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCubeLeftIn',
    outClass: 'animated-section-rotateCubeLeftOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCubeRightIn',
    outClass: 'animated-section-rotateCubeRightOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCubeTopIn',
    outClass: 'animated-section-rotateCubeTopOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCubeBottomIn',
    outClass: 'animated-section-rotateCubeBottomOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCarouselLeftIn',
    outClass: 'animated-section-rotateCarouselLeftOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCarouselRightIn',
    outClass: 'animated-section-rotateCarouselRightOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCarouselTopIn',
    outClass: 'animated-section-rotateCarouselTopOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateCarouselBottomIn',
    outClass: 'animated-section-rotateCarouselBottomOut animated-section-ontop'
  },
  {
    inClass: 'animated-section-rotateSidesIn animated-section-delay200',
    outClass: 'animated-section-rotateSidesOut'
  },
  {
    inClass: 'animated-section-rotateSlideIn',
    outClass: 'animated-section-rotateSlideOut'
  }
]
